import React from "react";
import { InstallWidgetModal } from "./modals/InstallWidgetModal";
import CreateWidgetModal from "../../../parts/modals/create-widget";
import { EditVideoPlaylistModal } from "./modals/EditVideoPlaylistModal";
import LearnMore from "./screens/LearnMore";
import WidgetsMain from "./screens/WidgetsMain";
import WidgetManager from "./screens/WidgetManager";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import { InAppMealPlannerModal } from "./modals/InAppMealPlannerModal";

const WidgetsController = async ({ res, req, locals, load }) => {
  const { query = {} } = req;
  const modal = query.modal || {};
  const { activeUser } = locals;

  if (activeUser.organizationId) {
    await load("widgetsOrganization");
  } else {
    await load("widgets");
  }

  if (query.widget && (locals.widgets || locals.widgetsOrganization)) {
    const widgets = locals.widgets || locals.widgetsOrganization;
    locals.activeWidget = widgets.find(({ _id }) => _id === query.widget);
  }

  if (locals.activeWidget) {
    const { _id, type } = locals.activeWidget;
    switch (type) {
      case "recipe":
        await load("recipes", { widget: _id });
        break;
      case "store":
        await load("widgetStores", { widget: _id });
        break;
      case "video-playlist":
        await load("videoPlaylists", { widget: _id });
        break;
      case "macro-calculator":
        await load("macroCalculator", { widget: _id });
        break;
      case "links":
        await load("widgetLinks", { widget: _id });
        break;
      case "file-documents":
        await load("widgetFiles", { widget: _id });
        break;
      case "meal-plan-library":
        await load("mealPlanLibraries", { widget: _id });
        break;
      case "daily-accountability-template":
        await load("dailyAccountabilityTemplates", { widget: _id });
        break;
      default:
        break;
    }
  }

  if (query.thumbnail) {
    await load("widgetLinkThumbnail", { url: query.thumbnail });
  }
  const sections = {
    learn: <LearnMore section={query.learn} />,
    main: <WidgetsMain locals={locals} />,
    manager: <WidgetManager locals={locals} type={query.type} />,
  };

  switch (modal.type) {
    case "in-app-meal-planner":
      await load("mealPlanTemplates", {
        customLimit: 1,
        customSkip: 1,
        noPagination: true,
        planMode: "detailed",
      });
      break;
    default:
      break;
  }

  locals.modal = {
    "create-widget": <CreateWidgetModal type={query.type} />,
    "edit-video-playlist": (
      <EditVideoPlaylistModal query={query} locals={locals} />
    ),
    "install-widget": <InstallWidgetModal query={query} />,

    "activity-feed": <ActivityDrawer />,
    "in-app-meal-planner": <InAppMealPlannerModal locals={locals} />,
  }[modal.type];

  res.body = sections[query.section || "main"];
};

export default WidgetsController;
